const CURRENCY_AMOUNT = /(?:C\$|US\$|\$)\s*\d[\d,]*(?:\.\d{1,2})?|\b(?:CAD|USD)\s*:?\s*\d[\d,]*(?:\.\d{1,2})?|\b\d[\d,]*(?:\.\d{1,2})?\s*(?:CAD|USD)\b/i;
const MONEY_WORD = /\b(?:total|costs?|expenses?|spend|spent|price|paid|payment|invoice|bill|profit|balance|subtotal|tax)\b/i;
const AMOUNT = /\b\d[\d,]*(?:\.\d{1,2})?\b/g;

export function aiNoteMentionsCurrencyAmount(note: string): boolean {
  if (CURRENCY_AMOUNT.test(note)) return true;

  // Some AI summaries omit the currency after a combined total. Only flag a
  // nearby money word and amount; bare odometer and measurement decimals stay
  // ordinary notes and do not trigger the warning.
  for (const match of note.matchAll(AMOUNT)) {
    const start = Math.max(0, match.index - 48);
    const end = Math.min(note.length, match.index + match[0].length + 48);
    if (MONEY_WORD.test(note.slice(start, end))) return true;
  }
  return false;
}
